import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackPageView } from "../utils/analytics"

/**
 * Hook to automatically track page views when route changes
 * Place this in your main App component or a component that wraps all routes
 */
export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    // Get page title from document title or generate from pathname
    const pageTitle = document.title || getPageTitleFromPath(location.pathname)
    const pageLocation =
      window.location.origin + location.pathname + location.search

    // Track the page view
    trackPageView(pageTitle, pageLocation)
  }, [location])
}

/**
 * Generate a readable page title from the URL pathname
 * @param {string} pathname - The current pathname
 * @returns {string} - A formatted page title
 */
const getPageTitleFromPath = (pathname) => {
  // Remove leading slash and split by slashes
  const segments = pathname.replace(/^\//, "").split("/")

  if (segments[0] === "" || segments[0] === undefined) {
    return "Home"
  }

  // Convert pathname segments to title case
  return segments
    .map(
      (segment) =>
        segment
          .replace(/-/g, " ") // Replace hyphens with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()) // Title case
    )
    .join(" - ")
}

export default usePageTracking
